// Full dynamic-products module merged from legacy `assets/js/dynamic-products.js`.
import { debounce } from '../helpers/utils.js';
import plancAddToCart from '../helpers/planc-add-to-cart.js';

export function initDynamicProducts() {
    if (typeof window.PlancModules === 'undefined') window.PlancModules = {};
    if (window.PlancModules.dynamicProducts) return;
    window.PlancModules.dynamicProducts = true;

    try {
        const $ = window.jQuery || window.$;
        if (typeof $ === 'undefined') return;

        const PlanCDynamicProducts = {
            config: {
                selectors: {
                    container: '.planc-dynamic-products-section',
                    productsGrid: '.products-grid',
                    loadingOverlay: '.products-loading-overlay',
                    filters: '.product-filters',
                    filterSelect: '.filter-select',
                    filterCheckbox: '.filter-checkbox',
                    resetFilters: '.reset-filters',
                    addToCartBtn: '.add-to-cart-ajax, .add-to-cart-btn, .single_add_to_cart_button, .product .button',
                    quickViewBtn: '.quick-view-btn'
                },
                classes: { loading: 'loading', hidden: 'hidden', disabled: 'disabled' }
            },

            init: function() {
                this._debouncedFilterChange = debounce(this.handleFilterChange.bind(this), 250);
                this._debouncedWindowResize = debounce(this.handleWindowResize.bind(this), 250);
                this.bindEvents();
                this.initAjaxLoading();
                this.initFilters();
                this.initAddToCart();
                this.initQuickView();
                this.initLazyLoading();
            },

            bindEvents: function() {
                // Defer attaching per-container handlers until containers are discovered in DOMReady
                $(document).ready(() => { this.handleDOMReady(); });
                // Global window resize stays as-is
                $(window).on('resize', this._debouncedWindowResize);
            },

            handleDOMReady: function() {
                const self = this;
                $(this.config.selectors.container).each((index, element) => {
                    const $container = $(element);
                    const args = $container.data('args');
                    if (args && args.ajax_load) this.loadProducts($container, args);

                    // Bind filter/change handlers scoped to this container (safer than document delegation)
                    $container.off('change.plancFilters', this.config.selectors.filterSelect).on('change.plancFilters', this.config.selectors.filterSelect, function(e) { self._debouncedFilterChange(e); });
                    $container.off('change.plancFiltersCheckbox', this.config.selectors.filterCheckbox).on('change.plancFiltersCheckbox', this.config.selectors.filterCheckbox, function(e) { self._debouncedFilterChange(e); });
                    $container.off('click.plancReset', this.config.selectors.resetFilters).on('click.plancReset', this.config.selectors.resetFilters, function(e) { self.handleResetFilters(e); });

                    // Bind add-to-cart and quick-view within the container where product buttons live
                    $container.off('click.plancAdd', this.config.selectors.addToCartBtn).on('click.plancAdd', this.config.selectors.addToCartBtn, function(e) { self.handleAddToCart(e); });
                    $container.off('click.plancQuick', this.config.selectors.quickViewBtn).on('click.plancQuick', this.config.selectors.quickViewBtn, function(e) { self.handleQuickView(e); });
                });
                this.initAnimations();
            },

            initAjaxLoading: function() {},
            initFilters: function() { this.filterState = {}; this.initFilterFromURL(); },
            initAddToCart: function() {},
            initQuickView: function() {},

            initLazyLoading: function() {
                if ('IntersectionObserver' in window) {
                    const imageObserver = new IntersectionObserver((entries, _observer) => {
                        entries.forEach(entry => {
                            if (entry.isIntersecting) {
                                const img = entry.target;
                                img.src = img.dataset.src;
                                img.classList.remove('lazy');
                                imageObserver.unobserve(img);
                            }
                        });
                    });
                    document.querySelectorAll('img[data-src]').forEach(img => { imageObserver.observe(img); });
                }
            },

            initAnimations: function() {
                $(this.config.selectors.container).each((index, element) => {
                    const $container = $(element);
                    const cards = $container.find('.product-card');
                    cards.each((i, card) => { $(card).css({ 'animation-delay': (i * 100) + 'ms' }).addClass('animate-fade-in-up'); });
                });
            },

            handleFilterChange: function(event) {
                const $filter = $(event.target);
                const $container = $filter.closest(this.config.selectors.container);
                const filterType = $filter.data('filter');
                let filterValue = $filter.val();
                if ($filter.is(':checkbox')) filterValue = $filter.is(':checked');
                this.updateFilterState($container, filterType, filterValue);
                this.applyFilters($container);
            },

            handleResetFilters: function(event) {
                event.preventDefault();
                const $container = $(event.target).closest(this.config.selectors.container);
                $container.find(this.config.selectors.filterSelect).val('');
                $container.find(this.config.selectors.filterCheckbox).prop('checked', false);
                this.filterState = {};
                const originalArgs = $container.data('args');
                this.loadProducts($container, originalArgs);
            },

            handleAddToCart: function(event) {
                event.preventDefault();
                const $target = $(event.target);
                let $button = $(event.currentTarget && event.currentTarget !== document ? event.currentTarget : null);
                if (!$button || $button.length === 0) $button = $target.closest(this.config.selectors.addToCartBtn);
                if (!$button || $button.length === 0) $button = $target.parents().filter(this.config.selectors.addToCartBtn).first();
                if (!$button || $button.length === 0) {
                    const $prodCard = $target.closest('.product-card');
                    if ($prodCard && $prodCard.length) $button = $prodCard.find(this.config.selectors.addToCartBtn).first();
                }
                if (!$button || $button.length === 0) $button = $();

                let productId = $button.data('product-id') || $button.attr('data-product-id');
                if (!productId) {
                    const productSku = $button.data('product-sku') || $button.attr('data-product-sku');
                    if (productSku) { console.log('Using product SKU as fallback:', productSku); productId = productSku; }
                }
                if (!productId) {
                    const $anc = $target.parents().filter('[data-product-id]').first();
                    if ($anc && $anc.length) { productId = $anc.data('product-id') || $anc.attr('data-product-id'); $button = $anc; }
                }
                if (!productId) {
                    const $formInput = $target.closest('form').find('input[name="product_id"]').first();
                    if ($formInput && $formInput.length) { productId = $formInput.val(); const $wrap = $formInput.closest('[data-product-id]'); if ($wrap && $wrap.length) $button = $wrap; }
                }
                if (!productId) {
                    const $nearestBtn = $target.closest('button, a');
                    if ($nearestBtn && $nearestBtn.length) {
                        productId = $nearestBtn.data('id') || $nearestBtn.data('product-id') || $nearestBtn.attr('data-id') || $nearestBtn.attr('data-product-id') || $nearestBtn.attr('data-product') || $nearestBtn.attr('data-product_id');
                        if (!productId && $nearestBtn.is('a')) {
                            const href = $nearestBtn.attr('href') || '';
                            const m = href.match(/[?&]add-to-cart=(\d+)/);
                            if (m) productId = m[1];
                        }
                        if (!productId) {
                            const val = $nearestBtn.attr('value') || $nearestBtn.val(); if (val && /\d+/.test(val)) productId = val;
                        }
                        if (productId) $button = $nearestBtn;
                    }
                }

                if (!productId) {
                    try {
                        console.error('Product ID not found. Event target outerHTML:', $target[0] ? $target[0].outerHTML : 'No target');
                    } catch (err) { console.error('Error while collecting debug info for missing productId:', err); }
                    this.showNotice('Error: Product ID not found. Please check console for details.', 'error');
                    return;
                }

                // Use centralized wrapper if available
                try {
                    if (typeof plancAddToCart === 'function') {
                        this.setButtonLoading($button, true);
                        plancAddToCart({ productId: productId, quantity: 1, $button: $button, optimistic: true })
                            .then((response) => { this.setButtonLoading($button, false); })
                            .catch((err) => { this.setButtonLoading($button, false); this.showNotice('Error adding product to cart. Please try again.', 'error'); });
                        return;
                    }
                } catch (e) { if (window.PLANC_DEBUG && console) console.debug('plancAddToCart call failed', e); }

                // Fallback: if wrapper not available, show an error
                this.showNotice('Unable to add to cart (JS helper missing).', 'error');
            },

            handleQuickView: function(event) {
                event.preventDefault();
                const $button = $(event.target).closest(this.config.selectors.quickViewBtn);
                const productId = $button.data('product-id');
                if (!productId) return;
                const $productCard = $button.closest('.product-card');
                const productLink = $productCard.find('.product-info h3 a').attr('href');
                if (productLink) window.open(productLink, '_blank');
            },

            handleWindowResize: function() { this.adjustGridLayout(); },

            updateFilterState: function($container, filterType, filterValue) {
                const containerId = $container.attr('id');
                if (!this.filterState[containerId]) this.filterState[containerId] = {};
                this.filterState[containerId][filterType] = filterValue;
            },

            applyFilters: function($container) { const containerId = $container.attr('id'); const filters = this.filterState[containerId] || {}; const originalArgs = $container.data('args'); const filteredArgs = { ...originalArgs, ...filters }; this.loadProducts($container, filteredArgs); },

            loadProducts: function($container, args) {
                this.showLoadingOverlay($container, true);
                const ajaxCfg = window.planc_products_ajax || {};
                const data = { action: 'load_dynamic_products', args: JSON.stringify(args), nonce: ajaxCfg.nonce };
                $.ajax({ url: ajaxCfg.ajax_url || (window.location.origin + '/wp-admin/admin-ajax.php'), type: 'POST', data: data, success: (response) => {
                        this.showLoadingOverlay($container, false);
                        if (response.success) {
                            $container.find('.products-container').html(response.data.html);
                            this.initAnimations();
                            $container.trigger('productsLoaded', [response.data]);
                        } else { this.showNotice('Error loading products: ' + (response.data || 'Unknown error'), 'error'); }
                    }, error: () => { this.showLoadingOverlay($container, false); const ajaxCfg2 = window.planc_products_ajax || {}; this.showNotice(ajaxCfg2.error_text || 'Error loading products', 'error'); }
                });
            },

            showLoadingOverlay: function($container, show) { const $overlay = $container.find(this.config.selectors.loadingOverlay); if (show) { $overlay.removeClass(this.config.classes.hidden); } else { $overlay.addClass(this.config.classes.hidden); } },

            setButtonLoading: function($button, loading) { const $text = $button.find('.button-text'); const $spinner = $button.find('.fa-spinner'); if (loading) { $button.prop('disabled', true).addClass(this.config.classes.loading); $text.text('Adding...'); $spinner.removeClass('hidden'); } else { $button.prop('disabled', false).removeClass(this.config.classes.loading); $text.text('Add to Cart'); $spinner.addClass('hidden'); } },

            showNotice: function(message, type = 'info') { try { if (window.PlancNotify && typeof window.PlancNotify.show === 'function') { window.PlancNotify.show(message, type); return; } } catch (e) { if (window.PLANC_DEBUG && typeof console !== 'undefined') console.debug('PlancNotify.show failed', e); }
                const $notice = $(`
                <div class="planc-notice planc-notice-${type} fixed top-4 right-4 z-50 max-w-sm bg-white border border-gray-200 rounded-lg shadow-lg p-4 transform translate-x-full transition-transform duration-300">
                    <div class="flex items-center">
                        <div class="flex-shrink-0">
                            <i class="fas fa-${this.getNoticeIcon(type)} text-${this.getNoticeColor(type)}-500"></i>
                        </div>
                        <div class="ml-3">
                            <p class="text-sm font-medium text-gray-900">${message}</p>
                        </div>
                        <div class="ml-auto pl-3">
                            <button class="notice-close text-gray-400 hover:text-gray-600">
                                <i class="fas fa-times"></i>
                            </button>
                        </div>
                    </div>
                </div>
            `);
                $('body').append($notice);
                setTimeout(() => { $notice.removeClass('translate-x-full'); }, 100);
                setTimeout(() => { this.hideNotice($notice); }, 5000);
                $notice.find('.notice-close').on('click', () => { this.hideNotice($notice); });
            },

            hideNotice: function($notice) { $notice.addClass('translate-x-full'); setTimeout(() => { $notice.remove(); }, 300); },

            getNoticeIcon: function(type) { const icons = { success: 'check-circle', error: 'exclamation-circle', warning: 'exclamation-triangle', info: 'info-circle' }; return icons[type] || icons.info; },

            getNoticeColor: function(type) { const colors = { success: 'green', error: 'red', warning: 'yellow', info: 'blue' }; return colors[type] || colors.info; },

            initFilterFromURL: function() { /* reserved for reading filter params from URL */ },

            adjustGridLayout: function() {},

            // Using shared debounce from helpers via import; kept placeholder to preserve API surface for older callers
            debounce: function(func, wait, immediate) { return debounce(func, wait, immediate); }
        };

        $(document).ready(function() { PlanCDynamicProducts.init(); });

        // Expose global for backward compatibility
        window.PlanCDynamicProducts = window.PlanCDynamicProducts || PlanCDynamicProducts;

    } catch (e) {
        if (window.PLANC_DEBUG && typeof console !== 'undefined') console.debug('initDynamicProducts failed', e);
    }
}
